module.exports = __webpack_public_path__ + "img/hr-tank-base-mask-3.c4b8bd7f.png";